import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import validator from "validator";
import { connect } from "react-redux";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperSpinner from "../../../helpers/spinner";
import helperNumbers from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import httpService from "../../../services/httpServices/httpServices";

function AddTransactionScoreToWalletAdvertiser({ userScore }) {
  const [score, setScore] = useState(0);
  const [walletAdvertiser, setWalletAdvertiser] = useState(0);
  const history = useHistory();
  const [message, setMessage] = useState();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }
  useEffect(() => {
    if (score < 0) {
      return;
    }
    setWalletAdvertiser(
      Math.floor(
        score /
          process.env.REACT_APP_COEFFICIENT_CONVERT_SCORE_TO_WALLET_PUBLISHER
      )
    );
  }, [score]);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestAddTransactionScoreToWalletAdvertiser = async (data) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/transaction-score-to-wallet-advertiser",
        data,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const inputScoreChangeHandler = (e) => {
    let number = e.target.value;
    number = helperNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setScore(parseInt(number));
  };

  const inputScoreBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const sendForm = async () => {
    if (score > userScore) {
      setMessage({
        type_class: "alert alert-danger",
        text: "Hicoin وارد شده بیشتر از Hicoin شما هست. ",
        class_icon: "fa fa-exclamation-triangle",
      });
      return;
    }
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultSendRequestAddTransactionScoreToWalletAdvertiser =
      await sendRequestAddTransactionScoreToWalletAdvertiser({
        score: score + "",
      });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultSendRequestAddTransactionScoreToWalletAdvertiser) {
      return;
    }

    history.push("/finance/all-transaction-score-to-wallet-advertiser");
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="درخواست تبدیل Hicoin به شارژ تبلیغ دهنده" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/all-transaction-score-to-wallet-advertiser"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {messageTag}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="form-group">
                  <label>Hicoin</label>
                  <input
                    tabindex="1"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(score)
                    )}
                    onChange={inputScoreChangeHandler}
                    onBeforeInput={inputScoreBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>شارژ تبلیغ دهنده (تومان)</label>
                  <div className="text-left" style={{ fontSize: "30px" }}>
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(walletAdvertiser)
                    )}
                  </div>
                  <div className="form-group">
                    <button className="btn btn-success">تبدیل</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    userScore: state.main.score,
  };
};

export default connect(
  mapStateToProps,
  null
)(AddTransactionScoreToWalletAdvertiser);
